const TTS_AUTOPLAY_ENABLED_KEY = 'infinity-memoburst-tts-autoplay-enabled';

export function isTtsAutoplayEnabled() {
  if (typeof localStorage === 'undefined') return true;
  return localStorage.getItem(TTS_AUTOPLAY_ENABLED_KEY) !== 'false';
}

export function setTtsAutoplayEnabled(enabled) {
  const normalized = Boolean(enabled);
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(TTS_AUTOPLAY_ENABLED_KEY, normalized ? 'true' : 'false');
  }
  return normalized;
}

export { TTS_AUTOPLAY_ENABLED_KEY };
